import React from 'react';
import { ReactSortable } from 'react-sortablejs';
import styles from 'styles/Course.module.scss';
import { parseHtml } from 'helpers';

const Ordering = ({ value = [], onChange, readOnly }) => {
  return (
    <div>
      <ReactSortable
        className="mb-2"
        list={value}
        setList={onChange}
        disabled={readOnly}
        animation={220}
        forceFallback
        easing="cubic-bezier(1, 0, 0, 1)"
        selectedClass={styles['item-section-selected']}
      >
        {value.map((item) => {
          return (
            <div
              key={item?.id}
              className={
                `col cursor-pointer position-relative flexRow px-md-2 px-05 py-05 ordering-content-test ${styles['item-section-normal']} user-select-none` +
                ` ${styles['item-section-enabled']}`
              }
              style={{ maxWidth: '40rem', '--labelcolor': '#c1c9d4' }}
            >
              <span className={`w-100 ${styles['item-unit-label']}`}>
                <span
                  className={`drag-overflow-image ${styles['item-unit-title']}`}
                >
                  {parseHtml(item?.content)}
                </span>
              </span>
            </div>
          );
        })}
      </ReactSortable>
    </div>
  );
};

export default Ordering;
